import * as Yup from 'yup';
import { t } from 'i18next';

export const ClientSchema = () => Yup.object().shape({
    textarea: Yup.string()
        .required(t('validation.required')),
});
